<div>
  <mat-card class="mat-elevation-z8">
    <div class="row">
      <div class="col"></div>
      <div class="col-1">
      </div>

    </div>
    <form [formGroup]="product_register_form">

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Product Group <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <select class="form-control dropdown_box" formControlName='group_id'  [attr.disabled]="action == 'update' ? 'disabled' : null">
              <option *ngFor="let product of product_group" [value]="product['id']">{{product['name']}} </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='name'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Short Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='short_name' [attr.disabled]="action == 'update' ? 'disabled' : null">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Code <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='code' [attr.disabled]="action == 'update' ? 'disabled' : null">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Quantity <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="form-control code_box" formControlName='quantity' [attr.disabled]="action == 'update' ? 'disabled' : null">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Unit <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <select class="form-control dropdown_box" formControlName='unit_id' [attr.disabled]="action == 'update' ? 'disabled' : null">
              <option *ngFor="let unit of product_units" [value]="unit['id']">{{unit['name']}} </option>
            </select>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Base Price <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="form-control code_box" formControlName='base_price' [attr.disabled]="action == 'update' ? 'disabled' : null">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Gst Percentage <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="form-control code_box" formControlName='gst_percent' [attr.disabled]="action == 'update' ? 'disabled' : null">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Mrp <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="form-control code_box" formControlName='mrp'>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Private Institute Discount Price <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="number" class="form-control code_box" formControlName='pvt_discount_price'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Govt Institute Discount price <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="number" class="form-control code_box" formControlName='gvt_discount_price'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Society price <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="number" class="form-control code_box" formControlName='society_price'>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Fat</label>
            <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="form-control code_box" formControlName='fat'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Snf</label>
            <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="form-control code_box" formControlName='snf'>
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label>is_homogenised</label>
            <mat-checkbox class="form-control" style="    border: none;"></mat-checkbox>
            <!-- <input type="checkbox" class="form-control" formControlName='is_homogenised'> -->
          </div>
        </div>
      </div>
      <div>
        <div class="col">
          <div class="form-group">
            <label>Description <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='description'>
          </div>
        </div>
      </div>
      <button mat-raised-button color="primary" (click)="registerProduct()" [disabled]="!product_register_form.valid"
        style="text-transform: capitalize">{{action}}</button>
    </form>
  </mat-card>
</div>
